<template>
    <div class="vm-plan-sale flex-box flex-align-self-start relative" :class="[browser_size]">
        <pic v-if="cover || plan.pic" class="cover mr16" :style="{width: cover_w+ 'px', height: cover_h+ 'px'}" :width="cover_w" :height="cover_h" :src="cover || plan.pic"/>
        <div class="right-box">
            <tag v-if="plan.time_limit_price" class="purple circle pt4 pr10 pb4 pl10 lh1">{{$t('c.PlanSale.text1')}}</tag> 
            <div v-if="name || plan.name" class="lh1_2 black-8 fs14 name-box break-all mt8 text-overflow-1">{{plan.product_type == 4 ? plan.name : (name || plan.name)}}</div>
            <div v-if="plan.product_type == 2 && is_show_bundle" class="lh1 fs12 black-5 fwn mt8 mb16">{{$t('c.PlanSale.text2')}}<template v-if="is_show_bundle_info"> · {{$t('c.PlanSale.text3')}} {{plan.bundle_sku_count || (plan.sku && plan.sku.length)}} {{$t('c.PlanSale.text5')}}</template></div>
            <div v-if="plan.product_type == 3 && is_show_bundle" class="lh1 fs12 black-5 fwn mt8 mb16">{{$t('c.PlanSale.text2')}}<template v-if="is_show_bundle_info"> · {{$t('c.PlanSale.text4')}} {{plan.bundle_sku_select_count}} {{$t('c.PlanSale.text5')}}</template></div>
            <div v-if="plan.product_type == 4 && sku_detail" class="lh1 fs12 black-5 fwn mt8">
              <tag class="gray size2">{{$time_show(sku_detail[0].ticket_round_begin_time * 1000, 'YYYY-MM-DD HH:mm', true)}}</tag>
              <tag class="ml8 gray size2">{{sku_detail[0].name}}</tag>
            </div>
            <div v-if="plan.product_type == 4 && order && order.show_amount && is_show_all_amount" class="black-8 mt20 fs14 fwb"><template v-if="is_show_amount">¥{{order.show_amount}} * </template>{{order.sku_count}}张</div>
            <div v-if="!plan.is_vip && plan.product_type != 4" class="flex-box flex-align-items-baseline price-box flex-wrap">
              <span v-if="sku_count > 0" class="t2 mr8 black-8">{{sku_count}} {{$t('c.PlanSale.text6')}}</span>
              <span v-else class="mr8" :class="{purple: plan.time_limit_price}">
                <span class="t1">¥ {{ time_limit_price || plan.price}}</span>
                <span v-if="plan.product_type != 4" class="ml4 t2" :class="[time_limit_price ? 'purple': 'black-8']">{{$t('c.PlanSale.text7')}}</span>
              </span>
              <div class="flex-box flex-a-center">
                <span class="purple mr8 fs12" v-if="plan.vip_price">¥{{plan.vip_price}}{{$t('c.PlanSale.text8')}}</span>
                <del v-if="plan.time_limit_price" class="black-3 mr8 fs12">¥{{plan.price}}</del>
              </div> 
            </div>
            <div v-if="plan.is_vip == 1 && plan.product_type != 4" class="flex-box flex-align-items-baseline price-box flex-wrap">
              <span v-if="sku_count > 0" class="t2 black-8">{{sku_count}} {{$t('c.PlanSale.text6')}}</span>
              <div class="purple mr8" v-else>
                <span class="t1">¥ {{ time_limit_price ? plan.time_limit_price.price : plan.vip_price }}</span>
                <span class="ml8 purple">{{$t('c.PlanSale.text7')}}</span>
              </div>
              <div class="flex-box flex-a-center">
                <span v-if="time_limit_price" class="purple mr8 fs12">¥{{plan.vip_price}}{{$t('c.PlanSale.text8')}}</span>
                <span v-if="!time_limit_price" class="purple mr8 fs12">{{$t('c.PlanSale.text8')}}</span>
                <del class="black-3 fs12">¥{{plan.price}}</del>
              </div> 
            </div>
            <div class="fs14 black-3 mt16" v-if="plan.sponsor_count > 0">{{plan.sponsor_count}} {{$t('c.PlanSale.text9')}}</div>
            <div class="black-3 fs12 mt12" v-if="plan.plan_id == 'e67b387ad08011ed8a2152540025c377'">
              <p>任选两件，每件优惠8元</p>
              <p>任选三件或以上，每件优惠10元</p>
            </div> 
            <div class="black-3 fs12 mt12" v-if="plan.plan_id == '14e46c18d08111edbc6952540025c377'">
              <p>任选两体，每体优惠10元</p>
              <p>任选三体，每体优惠12元</p>
              <p>任选四体及以上，每体优惠14元</p>
            </div> 
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    order: {
      default() {
        return {};
      }
    },
    plan: {
      default() {
        return {};
      }
    },
    cover:{
        default(){
            return ''
        }
    },
    cover_w:{
        default(){
            return 120
        }
    },
    cover_h:{
        default(){
            return 120
        }
    },
    name:{
        default(){
            return ''
        }
    },
    sku_count:{
      default(){
          return 0
      }
    },
    is_show_all_amount:{
      default(){
          return true
      }
    },
    is_show_amount:{
      default(){
          return true
      }
    },
    is_show_bundle:{
      default(){
          return true
      }
    },
    is_show_bundle_info:{
      default(){
          return true
      }
    },
  },
  data() {
    return {
      sku_detail:this.order.sku_processed || this.order.sku_detail
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  computed: {
    time_limit_price(){
      if(this.plan.time_limit_price){
        return this.plan.time_limit_price.price
      }
      return ''
    },
    // floor_price(){
    //   let min = this.plan.price
    //   if(this.plan.vip_price){
    //     min = Math.min(min, this.plan.vip_price)
    //   }
    //   if(this.time_limit_price != ''){
    //     min = Math.min(min, this.time_limit_price)
    //   }
    //   return min * 1 + '.00'
    // }
  },
  mounted() {},
  methods: {
  }
};
</script>

<style lang="stylus" scoped>
.vm-plan-sale {
    background rgba(0,0,0,.02);
    .cover{
        width 120px;
        height 120px;
    }
    .t1{
      font-size:22px;
    }
    .t2{
      font-size:14px;
    }
    .right-box{
        // padding:0px 16px;
        box-sizing: border-box;
    }
    .name-box{
        margin-bottom:8px;
    }
    &.look3{
        .cover{
            width 64px;
            height 64px;
        }
    }
    &.white-bg{
      background: $white;
    }
    &.look2{
        background rgba(0,0,0,0);
        .cover{
            width 48px;
            height 48px;
        }
        .price-box{
            font-size:14px;
        }
        .t1{
            font-size:14px;
            color:$black-3;
        }
        .t2{
            font-size:14px;
            color:$black-3;
        }
        .right-box{
            // margin:8px 12px;
        }
        .name-box{
            margin-bottom:8px;
        }
    }
    &.small {
        // padding: 0 16px;
    }
}
</style>
